export default "__VITE_ASSET__DwUEzFtF__"